import type { AlunoBloqueioAcesso } from '@/domain/model/AlunoBloqueioAcesso';
import type {
  BloquearAcessoAlunoUseCase, DesbloquearAcessoAlunoUseCase,
  ListBloqueiosAcessoUseCase, FindBloqueioAtivoUseCase,
} from '@/application/port/in/AlunoBloqueioAcessoUseCase';
import type {
  AlunoBloqueioAcessoGateway, BloquearAcessoCommand, DesbloquearAcessoCommand,
} from '@/application/port/out/AlunoBloqueioAcessoGateway';

export class BloquearAcessoAlunoUseCaseImpl implements BloquearAcessoAlunoUseCase {
  constructor(private readonly gw: AlunoBloqueioAcessoGateway) {}
  execute(c: BloquearAcessoCommand): Promise<AlunoBloqueioAcesso> { return this.gw.bloquear(c); }
}
export class DesbloquearAcessoAlunoUseCaseImpl implements DesbloquearAcessoAlunoUseCase {
  constructor(private readonly gw: AlunoBloqueioAcessoGateway) {}
  execute(c: DesbloquearAcessoCommand): Promise<AlunoBloqueioAcesso> { return this.gw.desbloquear(c); }
}
export class ListBloqueiosAcessoUseCaseImpl implements ListBloqueiosAcessoUseCase {
  constructor(private readonly gw: AlunoBloqueioAcessoGateway) {}
  execute(alunoId: string): Promise<AlunoBloqueioAcesso[]> { return this.gw.listByAluno(alunoId); }
}
export class FindBloqueioAtivoUseCaseImpl implements FindBloqueioAtivoUseCase {
  constructor(private readonly gw: AlunoBloqueioAcessoGateway) {}
  execute(alunoId: string): Promise<AlunoBloqueioAcesso | null> { return this.gw.findAtivo(alunoId); }
}
